export type TMenuItemSize = 'small-1' | 'small-2' | 'medium-1' | 'medium-2';

export enum MenuItemStyle {
  Danger = 'danger',
  BrandPrimary = 'brand-primary',
}
